<template>
    <div :class="[$style.card, $style[props.type]]">
        <svg
            :class="$style.svg"
            viewBox="0 0 100 100"
        >
            <image
                v-if="props.type === 'roblox'"
                :href="logo[props.type]"
                x="10"
                y="10"
                width="90"
                height="20"
            />
            <image
                v-else-if="props.type === 'amazon'"
                :href="logo[props.type]"
                x="10"
                y="10"
                width="70"
                height="30"
            />
            <Typography
                is="text"
                :class="$style.value"
                accent
                x="8"
                y="94"
                font-size="20"
                dominant-baseline="text-after-edge"
            >
                {{ currencySign }}{{ props.value }}
            </Typography>
        </svg>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { Currency } from '@/types'
import Typography from '@/components_new/Typography.vue'
import AmazonLogo from './images/amazon_logo.svg'
import RobloxLogo from './images/roblox_logo.svg'

type RewardCardProps = {
    type: 'roblox' | 'amazon'
    value: number
    currency: Currency
}
const props = defineProps<RewardCardProps>()

const logo: Record<RewardCardProps['type'], string> = {
    roblox: RobloxLogo,
    amazon: AmazonLogo,
}

const currencySign = computed(() => {
    if (props.currency === 'eur') {
        return '€'
    }
    return '$'
})
</script>
<style module>
.card {
    border-radius: 12px;
    aspect-ratio: var(--thumbnail-aspect-ratio);
    position: relative;
}

.svg {
    height: 100%;
    position: absolute;
}

.value {
    fill: var(--white);
}

.amazon {
    border: 1px solid var(--white-16);
    background: linear-gradient(239deg, rgba(13, 13, 15, 0.7) 2.34%, rgba(39, 39, 47, 0.7) 85.96%), #000;
    background-clip: padding-box;
}

.roblox {
    background: url('./images/roblox_bg.webp') center/cover;
}
</style>
